import { useLocation } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { AnswerTypeEnum } from '../../../constants/enums';
import useCreateScreening from '../../../hooks/useCreateScreening';
import { t } from '../../../i18n/i18n';
import { TrackEventGTM } from '../../../utils/filters/analyticsUtils';
import '../AddQuestion.scss';
import { CREATE_EVALUATION } from '../../../constants/routes';
import { EventsGTM } from '../../../constants/events';

const AnswerTypeButton = ({
  button,
  index,
  selected = null,
  addClass = '',
  iconButton,
  disabled = false,
}) => {
  const { pathname } = useLocation();
  const track = pathname === CREATE_EVALUATION;
  const { currentTypeQuestion, handleCurrentTypeQuestion } = useCreateScreening();
  return (
    <button
      type="button"
      key={button.id}
      onClick={() => {
        if (track) {
          TrackEventGTM(EventsGTM.CHANGE_CUSTOM_QUESTION_TYPE, {
            event_label: button.id,
            event_action: 'click',
            event_category: 'SelectCustomQuestionType',
          });
        }
        if (button.id && !disabled) handleCurrentTypeQuestion(button.id);
      }}
      className={`w-100 gap-1 border-none text-buttons text-title font-weight-500 d-flex justify-content-start align-items-center position-relative ${addClass} ${
        (currentTypeQuestion === AnswerTypeEnum.RADIO
          ? AnswerTypeEnum.CHECK
          : currentTypeQuestion) === button.id ||
        ([AnswerTypeEnum.TEXT_AI, AnswerTypeEnum.TEXT].includes(currentTypeQuestion) &&
          [AnswerTypeEnum.TEXT_AI, AnswerTypeEnum.TEXT].includes(button.id)) ||
        ([AnswerTypeEnum.VIDEO_AI, AnswerTypeEnum.VIDEO].includes(currentTypeQuestion) &&
          [AnswerTypeEnum.VIDEO_AI, AnswerTypeEnum.VIDEO].includes(button.id)) ||
        (selected && selected === button.id)
          ? `${
              button?.greenColor ? 'bg-green-principal' : 'bg-blue-principal'
            } color-white svg-selected`
          : `${button?.greenColor ? 'bg-green-secondary' : 'bg-blue-light'} color-grey-1`
      }
      ${index === 0 && !addClass && 'mt-0'}
      `}
      data-testid={`add-questions-current-type-${index}-btn`}
    >
      {button?.img}
      {!iconButton && button.name}
      {button?.img2 && (
        <div className="additional-image">
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip className=" font-size-tiny">{t('CORRECTION_POWERED_BY_AI')}</Tooltip>}
          >
            <div>{button?.img2}</div>
          </OverlayTrigger>
        </div>
      )}
    </button>
  );
};

export default AnswerTypeButton;
